import React, { PureComponent } from 'react';
import EnhancedFormattingMenu from './enhanced-formatting-menu';
import { Popover } from "@vitalsource/vstui/labs";
import { Icon, Button } from '@vitalsource/vstui';

export class EnhanceFormattingIcon extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={18} width={25}>
        <g fill="#40404C" fillRule="evenodd"><path d="M6.017 1L0 16.79h2.143l1.483-4.132h6.6l1.506 4.132h2.131L7.835 1H6.017zm.91 2.57l2.683 7.386H4.254L6.927 3.57zM19.578 15.26a3.51 3.51 0 0 0 1.785-.488c.563-.325.97-.748 1.224-1.268v-2.408h-1.57c-2.453 0-3.68.72-3.68 2.159 0 .629.21 1.12.628 1.474.419.354.957.532 1.613.532zm3.322 1.53c-.114-.232-.21-.644-.28-1.237-.932.97-2.042 1.453-3.334 1.453-1.154 0-2.101-.326-2.842-.98-.738-.655-1.108-1.484-1.108-2.49 0-1.22.463-2.17 1.39-2.846.928-.677 2.23-1.015 3.912-1.015h1.949v-.92c0-.702-.21-1.26-.628-1.676-.419-.416-1.035-.624-1.85-.624-.715 0-1.314.18-1.797.542-.483.362-.725.8-.725 1.312h-2.014c0-.586.208-1.15.623-1.697.415-.546.977-.978 1.689-1.296a5.67 5.67 0 0 1 2.342-.477c1.349 0 2.407.339 3.171 1.014.765.676 1.163 1.607 1.19 2.792v5.4c0 1.079.137 1.935.412 2.571v.174h-2.1z"/></g>
      </Icon>
    );
  }
}

EnhanceFormattingIcon.displayName = 'EnhanceFormattingIcon';
EnhanceFormattingIcon.vstuiName = 'Icon';

const EnhancedFormatting = ({id, isbn}) => (
  <Popover content={<EnhancedFormattingMenu isbn={isbn} />}>
    <Button
      id={id}
      iconStart={<EnhanceFormattingIcon />}
      className="scrubber-button"
      naked
      label={i18n.t('enhanced-formatting.enhanced-formatting')}
    />
  </Popover>
);

EnhancedFormatting.defaultProps = {
  onClick: () => {},
};

export default EnhancedFormatting;
